import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltersDrawerComponent } from './filters-drawer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DrawersCoreModule } from '../drawers-core.module';
import { DrawersModule } from '../drawers.module';
import { CheckboxItemComponent } from '@shared/components';

@NgModule({
  declarations: [FiltersDrawerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DrawersCoreModule,
    DrawersModule,
    CheckboxItemComponent,
  ],
  exports: [FiltersDrawerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FiltersDrawerModule {}
